module.exports = __webpack_public_path__ + "static/media/favicon_vema.7644c117.ico";